import { BackgroundColors } from '@picsart/design-system/foundation/colors';
import { TypographyT4 } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles<string, { expandedText?: boolean }>(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      rowGap: Spacings.s16,
      maxWidth: '100%',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      fontWeight: FontWeights.semibold,
      fontSize: TypographyT4,
    },
    inlineButton: {
      display: 'flex',
      justifyContent: 'flex-start',
      padding: 0,
    },
    t5: {
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 2,
      overflow: 'hidden',
    },
    content: {
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': props => !props.expandedText && 4,
      overflow: 'hidden',
      maxWidth: '100%',
      position: 'relative',
      '&::after': {
        display: props => (props.expandedText ? 'none' : 'flex'),
        position: 'absolute',
        content: '""',
        top: '40%',
        width: '100%',
        height: '60%',
        [BreakPointsMedia.SM]: {
          background: props => !props.expandedText && BackgroundColors.gradientUp,
        },
        [BreakPointsMedia.XS]: {
          background: props => !props.expandedText && BackgroundColors.gradientUp,
        },
        [BreakPointsMedia.XXS]: {
          background: props => !props.expandedText && BackgroundColors.gradientUp,
        },
        zIndex: 1,
      },
    },
  },
  {
    name: 'description',
  },
);

export default useStyles;
